(function () {

    'use strict';


    /* =========================================================
       CONFIGURATION
    ========================================================= */

    var GA4_ID = 'G-6G4K1P9WGJ';

    var PASSWORD_CONSENT_KEY =
        'mots_password_cookie_consent';


    /* =========================================================
       PAGE TYPE
    ========================================================= */

    function isPasswordPage() {

        return (
            window.MOTS_PASSWORD_PAGE === true
        );

    }


    /* =========================================================
       PASSWORD PAGE CONSENT
    ========================================================= */

    function getPasswordConsent() {

        if (!isPasswordPage()) {
            return null;
        }

        try {

            var stored =
                localStorage.getItem(
                    PASSWORD_CONSENT_KEY
                );

            if (!stored) {
                return null;
            }

            var consent =
                JSON.parse(stored);

            if (
                !consent ||
                typeof consent !== 'object'
            ) {
                return null;
            }

            return consent;

        } catch (error) {

            console.warn(
                'MOTS: Could not read password-page cookie consent.',
                error
            );

            return null;

        }

    }


    /* =========================================================
       ANALYTICS CONSENT
    ========================================================= */

    function analyticsAllowed() {

        /*
         * PASSWORD PAGE
         */

        if (isPasswordPage()) {

            var passwordConsent =
                getPasswordConsent();

            return !!(
                passwordConsent &&
                passwordConsent.analytics === true
            );

        }


        /*
         * NORMAL STOREFRONT
         */

        try {

            if (
                !window.Shopify ||
                !window.Shopify.customerPrivacy
            ) {
                return false;
            }

            var consent =
                window.Shopify.customerPrivacy
                    .currentVisitorConsent();

            return (
                consent &&
                consent.analytics === 'yes'
            );

        } catch (error) {

            console.warn(
                'MOTS: Could not read Shopify analytics consent.',
                error
            );

            return false;

        }

    }


    /* =========================================================
       MARKETING CONSENT
    ========================================================= */

    function marketingAllowed() {

        /*
         * PASSWORD PAGE
         */

        if (isPasswordPage()) {

            var passwordConsent =
                getPasswordConsent();

            return !!(
                passwordConsent &&
                passwordConsent.marketing === true
            );

        }


        /*
         * NORMAL STOREFRONT
         */

        try {

            if (
                !window.Shopify ||
                !window.Shopify.customerPrivacy
            ) {
                return false;
            }

            var consent =
                window.Shopify.customerPrivacy
                    .currentVisitorConsent();

            return (
                consent &&
                consent.marketing === 'yes'
            );

        } catch (error) {

            console.warn(
                'MOTS: Could not read Shopify marketing consent.',
                error
            );

            return false;

        }

    }


    /* =========================================================
       START GOOGLE ANALYTICS
    ========================================================= */

    function startAnalytics() {

        /*
         * IMPORTANT:
         *
         * This function is ONLY called after
         * analyticsAllowed() has returned true.
         */

        if (
            !analyticsAllowed()
        ) {
            return;
        }


        /*
         * Already initialized.
         */

        if (
            window.__MOTS_GA4_INITIALIZED__ === true
        ) {
            return;
        }


        /*
         * Create dataLayer only after analytics
         * consent has been granted.
         */

        window.dataLayer =
            window.dataLayer || [];


        /*
         * Create gtag only after analytics
         * consent has been granted.
         */

        window.gtag =
            window.gtag ||
            function () {

                window.dataLayer.push(
                    arguments
                );

            };


        /*
         * Initialize Google Analytics.
         */

        window.gtag(
            'js',
            new Date()
        );

        window.gtag(
            'config',
            GA4_ID
        );


        /*
         * Load the Google Analytics script.
         */

        var existingScript =
            document.querySelector(
                'script[data-mots-ga4="true"]'
            );


        if (!existingScript) {

            var script =
                document.createElement('script');

            script.async = true;

            script.src =
                'https://www.googletagmanager.com/gtag/js?id=' +
                GA4_ID;

            script.setAttribute(
                'data-mots-ga4',
                'true'
            );


            script.onload =
                function () {

                    console.log(
                        'MOTS: Google Analytics loaded.',
                        GA4_ID
                    );

                };


            script.onerror =
                function () {

                    console.error(
                        'MOTS: Google Analytics failed to load.',
                        GA4_ID
                    );

                };


            document.head.appendChild(
                script
            );

        }


        /*
         * Only NOW mark GA4 as initialized.
         */

        window.__MOTS_GA4_INITIALIZED__ = true;

    }


    /* =========================================================
       MARKETING
    ========================================================= */

    function startMarketing() {

        /*
         * Marketing scripts go here.
         */

    }


    /* =========================================================
       CHECK CONSENT
    ========================================================= */

    function checkConsent() {

        var analytics =
            analyticsAllowed();

        var marketing =
            marketingAllowed();


        /*
         * Analytics.
         */

        if (analytics) {

            startAnalytics();

        }


        /*
         * Marketing.
         */

        if (marketing) {

            startMarketing();

        }


        /*
         * Debug information.
         */

        console.log(
            'MOTS cookie gate:',
            {
                passwordPage:
                    isPasswordPage(),

                analytics:
                    analytics,

                marketing:
                    marketing,

                gaInitialized:
                    window.__MOTS_GA4_INITIALIZED__ === true,

                gtag:
                    typeof window.gtag === 'function',

                dataLayer:
                    Array.isArray(
                        window.dataLayer
                    )
            }
        );

    }


    /* =========================================================
       CONSENT EVENT
    ========================================================= */

    document.addEventListener(
        'visitorConsentCollected',
        function () {

            console.log(
                'MOTS: visitorConsentCollected received.'
            );

            checkConsent();

        }
    );


    /* =========================================================
       INITIAL CHECK
    ========================================================= */

    checkConsent();


    /* =========================================================
       PASSWORD PAGE FALLBACK
    ========================================================= */

    if (isPasswordPage()) {

        window.setTimeout(
            checkConsent,
            0
        );

        window.setTimeout(
            checkConsent,
            250
        );

    }


})();